<div class="models-container">
  <div>
    <mat-form-field appearance="fill" style="width: 300px">
      <mat-label>{{'Select League' | translate}}</mat-label>
      <mat-select (selectionChange)="loadTeams(selectedLeagueId)" [(ngModel)]="selectedLeagueId">
        <mat-option *ngFor="let league of leagues" [value]="league.id">{{ league.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-responsive" style="margin-top: 2rem;">
    <table [dataSource]="teams" class="mat-elevation-z8" mat-table>
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef class="text-center" mat-header-cell>{{'Team Name' | translate}}</th>
        <td *matCellDef="let team" class="text-center" mat-cell>{{ team.name }}</td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th *matHeaderCellDef class="text-center" mat-header-cell>{{'Edit' | translate}}</th>
        <td *matCellDef="let team" class="text-center" mat-cell>
          <button (click)="openEditTeamDialog(team)" mat-icon-button style="color: deepskyblue;">
            <i class="fa fa-edit"></i>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th *matHeaderCellDef class="text-center" mat-header-cell>{{'Remove' | translate}}</th>
        <td *matCellDef="let team" class="text-center" mat-cell>
          <button (click)="deleteTeam(team.id)" mat-icon-button style="color: red;">
            <i class="fa fa-remove"></i>
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
  </div>
</div>
